<template>
	<div class="createorder" ref="createorder">
		<el-form ref="createorderform" :style="{ height: `${windowHeight}px`, 'overflow-y': 'auto' }">
			<el-card class="box-card" label="选择渠道" shadow="hover" 
			v-if="(pmodelist.length>1||type=='海淘')&&(type!='退换货')">
				<div slot="header" class="clearfix"><span>选择渠道</span></div>
				<div style="display: inline;">
					<el-row>
						<el-col :span="5">
							<el-select size="mini" v-model="checkedpmode" @change="selectpmode" style="width:200px">
								<el-option v-for="(i, idx) in pmodelist" :key="idx" :label="i.d_name" :value="i.d_name"></el-option>
							</el-select>
						</el-col>
						<el-col :span="18">
							<div v-html="p_mode_remark"></div>
						</el-col>
					</el-row>
				</div>
			</el-card>
			<export1 ref="export1" v-if="type=='出口1'" @formScrollTop="formScrollTop" @cancel="cancel"></export1>
			<import1 ref="import1" v-if="type=='进口1'||type=='进口'" @formScrollTop="formScrollTop" @cancel="cancel"></import1>
			<import2 ref="import2" v-if="type=='进口2'" @formScrollTop="formScrollTop" @cancel="cancel"></import2>
			<inner1 ref="inner1" v-if="type=='境内包裹'" @formScrollTop="formScrollTop" @cancel="cancel"></inner1>
			<export2 ref="export2" v-if="type=='出口2'" @formScrollTop="formScrollTop" @cancel="cancel"></export2>
			<import3 ref="import3" v-if="type=='一件代发'" @formScrollTop="formScrollTop" @cancel="cancel"></import3>
			<export3 ref="export3" v-if="type=='出口3'" @formScrollTop="formScrollTop" @cancel="cancel"></export3>
			<import4 ref="import4" v-if="type=='海淘'" @formScrollTop="formScrollTop" @cancel="cancel"></import4>
			<createorderqg ref="createorderqg" v-if="type=='报关单'" @formScrollTop="formScrollTop" @cancel="cancel" :item="item"></createorderqg>
			
		</el-form>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
import export1 from '@/components/order/createorder_export_1.vue';
import import1 from '@/components/order/createorder_import_1.vue'; //下单选择商品库的，且选择的商品不可以更改信息，只可以更改数量
import inner1 from '@/components/order/createorder_inner_1.vue'; //境内包裹
import import2 from '@/components/order/createorder_import_2.vue'; //进口下单，可填写商品列表信息，不选择商品库
import export2 from '@/components/order/createorder_export_2.vue'; //出口下单，可填写商品列表信息，不选择商品库，仅可添加一个包裹
import import3 from '@/components/order/createorder_import_3.vue';
 //下单选择商品库的，按仓库匹配商品，无选择商品库按钮
import export3 from '@/components/order/createorder_export_3.vue'; //出口下单，可填写商品列表信息，不选择商品库，寄件 收件地址都可以随意添加任何国家的地址
import import4 from '@/components/order/createorder_import_4.vue';
//海淘， 可填写商品列表信息，不选择商品库，寄件 收件地址都可以随意添加任何国家的地址，先报价，再下单付费

import createorderqg from '@/components/order/createorder_qg.vue'; //报关订单填写，商品信息字段多，不在列表中填写，类似一个包裹一个包裹的填写方式 
export default {
	components: {
		export1,
		import1,
		inner1,
		import2,
		export2,
		import3,
		export3,
		import4,
		createorderqg
	},
	props: {
		item:{
			type: Object,
			default:function(){
				return {
					
				};
			}
		},
		l_id:{
			type: String,
			default:''
		}
	},
	data() {
		return {
			windowHeight: window.innerHeight - 120,
			pmodelist: [],
			divclass: 'createorder',
			syscol: '',
			t_id: '',
			p_mode_remark: '',
			checkedpmode: '',
			orderinfo: {},
			p_pkval: '',
			iscopy: 0, //0-新增 1-复制新增
			type:'',
			tbpostfix:''
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/packagemanager/createorder.scss');
		});
	},
	methods: {
		init(param) {
			debugger
			if (param.pkval != undefined) this.p_pkval = param.pkval;
			if (param.iscopy != undefined) this.iscopy = param.iscopy;
			if (param.tbpostfix != undefined) this.tbpostfix = param.tbpostfix;
			this.orderinfo={};
			if(param.orderinfo!=undefined)
				this.orderinfo=param.orderinfo;
			//this.pkval='SYS000000031';
			//this.iscopy='1';
			debugger
			if (this.p_pkval != '') {
				if(this.l_id=='')
					this.GetOrderInfo();
				else
					this.GetOrderInfo_new();
			} else {
				this.GetClarance();
			}
		},
		GetOrderInfo_new(){
			var that=this;
			this.$tool.loading(that.$lang.label.public.loading, this.divclass);
			var paraminfo={
				pkval:this.p_pkval,
				l_id:this.l_id,
				tbpostfix:this.tbpostfix
			}
			this.$apipost.get.GetOrderInfoByLid({paraminfo:paraminfo}).then(res => {
				this.$tool.loadingclose();
				if (res != '') {
					//debugger
					that.orderinfo = res;
					if(that.orderinfo.main!=undefined){
						if(that.orderinfo.main.p_mode!=undefined)
							that.checkedpmode=that.orderinfo.main.p_mode;
					}
					that.GetPageLayout();
				} else
					this.$tool.message(that.$lang.label.public.getinfofailed, "0");
			});
		},
		//获取渠道
		GetClarance() {
			var that = this;
			this.$tool.loading('正在加载', this.divclass);
			//先加载渠道
			this.$apipost.get.GetClarance().then(res => {
				//debugger
				that.pmodelist = res.list;
				if (that.pmodelist.length > 0) {
					if (that.orderinfo.p_mode!=undefined) {
						that.checkedpmode = that.orderinfo.p_mode;
						that.pmodelist.forEach(e => {
							if (e.d_name == that.checkedpmode) {
								that.p_mode_remark = e.remark;
								return false;
							}
						});
					} else {
						that.checkedpmode = that.pmodelist[0].d_name;
						that.orderinfo.p_mode = that.checkedpmode;
						that.p_mode_remark = that.pmodelist[0].remark;
					}
					that.GetPageLayout();
				} else {
					this.$tool.loadingclose();
				}
			});
		},
		//获取订单信息
		GetOrderInfo() {
			//获取订单信息
			this.$tool.loading('正在加载', this.divclass);
			var that=this;
			this.$apipost.get.GetOrderInfo_More({pkval:this.p_pkval}).then(res => {
				this.$tool.loadingclose();
				if(res.state=='1'){
					that.orderinfo=res.orderinfo;
					that.GetClarance();
					if(that.iscopy=='1'){
						that.p_pkval='';
					}
				}else{
					this.$tool.message(res.message,"0");
				}
			});
		},
		GetPageLayout() {
			var that = this;
			this.truncatepage();
			if (this.checkedpmode != '') {
				that.orderinfo.p_mode=this.checkedpmode;
				//判断是哪种类型的下单功能,显示对应组件
				this.$apipost.get.GetTransFormat({ p_mode: this.checkedpmode}).then(res => {
					this.$tool.loadingclose();
					//console.log('组件',res);
					if (res.state == '1') {
						if (res.set != undefined) {
							that.t_id = res.set.t_id;
							that.type=res.set.t_type ;
							if (that.type == '出口1')
								this.$nextTick(function() {
									that.$refs.export1.init({
									syscol: res.set.t_syscol,
									orderinfo: that.orderinfo,
									iscopy: that.iscopy,
									pkval: that.p_pkval,
									checkedpmode: that.checkedpmode,
									t_id: that.t_id
								});
							});
							else if (that.type == '进口1'){
								this.$nextTick(function() {
									that.$refs.import1.init({
									syscol: res.set.t_syscol,
									orderinfo: that.orderinfo,
									iscopy: that.iscopy,
									pkval: that.p_pkval,
									checkedpmode: that.checkedpmode,
									t_id: that.t_id
								});
								});
							}
							else if (that.type == '一件代发'){
								this.$nextTick(function() {
									that.$refs.import3.init({
									t_type:'一件代发',
									syscol: res.set.t_syscol,
									orderinfo: that.orderinfo,
									iscopy: that.iscopy,
									pkval: that.p_pkval,
									checkedpmode: that.checkedpmode,
									t_id: that.t_id,
									isselcargo:false
								});
								});
							}
							else if(that.type== '境内包裹')
							{
								this.$nextTick(function() {
									that.$refs.inner1.init({
									syscol: res.set.t_syscol,
									orderinfo: that.orderinfo,
									iscopy: that.iscopy,
									pkval: that.p_pkval,
									checkedpmode: that.checkedpmode,
									t_id: that.t_id
								});
							});
								
							}else if (that.type == '进口2'){
								this.$nextTick(function() {
									that.$refs.import2.init({
									syscol: res.set.t_syscol,
									orderinfo: that.orderinfo,
									iscopy: that.iscopy,
									pkval: that.p_pkval,
									checkedpmode: that.checkedpmode,
									t_id: that.t_id
								});
								});
							}
							else if (that.type== '出口2'){
								this.$nextTick(function() {
									that.$refs.export2.init({
									syscol: res.set.t_syscol,
									orderinfo: that.orderinfo,
									iscopy: that.iscopy,
									pkval: that.p_pkval,
									checkedpmode: that.checkedpmode,
									t_id: that.t_id
								});	
								});
							}
							else if (that.type == '出口3'){
								this.$nextTick(function() {
									that.$refs.export3.init({
									syscol: res.set.t_syscol,
									orderinfo: that.orderinfo,
									iscopy: that.iscopy,
									pkval: that.p_pkval,
									checkedpmode: that.checkedpmode,
									t_id: that.t_id
								});	
								});
							}
							else if (that.type == '海淘'){
								this.$nextTick(function() {
									that.$refs.import4.init({
									syscol: res.set.t_syscol,
									orderinfo: that.orderinfo,
									iscopy: that.iscopy,
									pkval: that.p_pkval,
									checkedpmode: that.checkedpmode,
									t_id: that.t_id
									});	
								});
							}
							else if(that.type=='报关单')
							{
								this.$nextTick(function() {
									that.$refs.createorderqg.init({
									syscol: res.set.t_syscol,
									orderinfo: that.orderinfo,
									iscopy: that.iscopy,
									pkval: that.p_pkval,
									checkedpmode: that.checkedpmode,
									t_id: that.t_id,
									pagetranscol:res.set.pagetranscol,
									type:that.type
								});	
							  });
							}
							if (that.type == '退货'||that.type == '换货'||that.type == '退换货'){
								this.$nextTick(function() {
									that.$refs.createorderqg.init({
									syscol: res.set.t_syscol,
									orderinfo: that.orderinfo,
									iscopy: that.iscopy,
									pkval: that.p_pkval,
									checkedpmode: that.checkedpmode,
									t_id: that.t_id,
									pagetranscol:res.set.pagetranscol,
									type:that.type
								});	
								});
							}
						}
					}
				});
			}
		},
		//切换渠道
		selectpmode(value) {
			var remark = '';
			if (value == this.orderinfo.p_mode) return;
			else {
				this.orderinfo.p_mode = value;
				this.pmodelist.forEach(e => {
					if (e.d_name == value) {
						remark = e.remark;
						return false;
					}
				});
				this.p_mode_remark = remark;
				this.GetPageLayout();
			}
		},
		//滚动条滚动到顶部
		formScrollTop() {
			this.$nextTick(() => {
				this.$refs.createorderform.$el.scrollTop = this.$refs.createorderform.$el.scrollHeight;
			});
		},
		//初始化页面
		truncatepage() {
			if (this.$refs.export1 != undefined) this.$refs.export1.isload = false;
			if (this.$refs.import1 != undefined) this.$refs.import1.isload = false;
			if (this.$refs.import2 != undefined) this.$refs.import2.isload = false;
			if (this.$refs.import3 != undefined) this.$refs.import3.isload = false;
			if (this.$refs.export2 != undefined) this.$refs.export2.isload = false;
			if (this.$refs.export3 != undefined) this.$refs.export3.isload = false;
			if (this.$refs.import4 != undefined) this.$refs.import4.isload = false;
			if (this.$refs.createorderqg != undefined) this.$refs.createorderqg.isload = false;
			if (this.$refs.returnexchange != undefined) this.$refs.returnexchange.isload = false;
		},
		cancel() {
			Utils.$emit('handleRermove', localStorage.getItem('tabname'));
		}
	}
};
</script>

<style></style>
